import { Close } from '@mui/icons-material';
import { AppBar, Grid, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import React, { useState } from 'react';
import GenButton from './GenButton';
import GenDataText from './GenDataText';

const StickyAppBar = ({
  display = false,
  title,
  subtitle,
  buttons,
  buttonsWrap = 'wrap',
  buttonsSx = {
    marginTop: { xs: 1, sm: 0 },
    marginLeft: { xs: 1 },
  },
}) => {
  const theme = useTheme();
  const [visible, setVisible] = useState(display);
  return visible ? (
    <AppBar
      position="sticky"
      color="primary"
      sx={{
        top: 'auto',
        bottom: 0,
        display: 'block',
        background: theme.palette.background.paper,
      }}
    >
      <Box p={2} sx={{ position: 'relative' }}>
        <Grid
          container
          flexDirection="row"
          justifyContent="space-between"
          alignItems={'center'}
        >
          <Grid
            item
            flexDirection="column"
            xs={11}
            sm={6}
            justifyItems="flex-start"
          >
            {title && (
              <GenDataText
                text={title}
                textVariant={'H6'}
                textColor={theme.palette.text.primary}
              />
            )}
            {subtitle && (
              <GenDataText
                text={subtitle}
                textVariant={'caption'}
                textColor={theme.palette.text.secondary}
              />
            )}
          </Grid>
          <Grid
            item
            flexDirection="column"
            width="100%"
            sx={{ alignItems: { xs: 'center', sm: 'flex-end' } }}
            xs={12}
            sm={6}
          >
            <Grid
              container
              flexDirection="row"
              width="100%"
              sx={{ justifyContent: { xs: 'space-evenly', sm: 'flex-end' } }}
              flexWrap={buttonsWrap}
            >
              <Box>
                <Grid
                  container
                  flexDirection="row"
                  sx={{ justifyContent: { xs: 'space-around', sm: 'none' } }}
                >
                  {buttons &&
                    buttons.map((b, i) => (
                      <Grid key={i} sx={buttonsSx}>
                        {b}
                      </Grid>
                    ))}
                </Grid>
              </Box>
              <Box
                pl={1}
                sx={{
                  position: { xs: 'absolute', sm: 'inherit' },
                  top: '10px',
                  right: '10px',
                }}
              >
                <GenButton
                  iconForIconButton={<Close />}
                  sx={{ color: theme.palette.action.active }}
                  onClick={() => setVisible(false)}
                />
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </AppBar>
  ) : null;
};

export default StickyAppBar;
